import React, { useEffect, useState } from 'react';
import { Heart, Clock, TrendingUp } from 'lucide-react';
import { storage } from '../../utils/storage';
import { MOOD_EMOJIS } from '../../utils/constants';
import { useTheme } from '../../hooks/useTheme';
import { useMoodData } from '../../hooks/useMoodData';

const QuickStats = ({ todayMood, onQuickCheckin }) => {
  const [stats, setStats] = useState({
    pomodoroCount: 0,
    totalMoodEntries: 0
  });
  const { theme } = useTheme();
  const { moodData } = useMoodData();

  useEffect(() => {
    const pomodoroSessions = storage.get('pomodoroSessions') || [];
    
    setStats({
      pomodoroCount: pomodoroSessions.filter(s => {
        const sessionDate = new Date(s.date);
        const weekAgo = new Date();
        weekAgo.setDate(weekAgo.getDate() - 7);
        return sessionDate >= weekAgo;
      }).length,
      totalMoodEntries: moodData.length
    });
  }, [moodData]);

  const cardClass = `p-6 rounded-xl ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-lg`;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className={cardClass}>
        <div className="flex items-center justify-between mb-4">
          <Heart className="w-8 h-8 text-red-500" />
          <span className="text-2xl">{todayMood ? MOOD_EMOJIS[todayMood.mood - 1] : '?'}</span>
        </div>
        <h3 className="font-semibold mb-1">Today's Mood</h3>
        <p className="text-sm text-gray-500">
          {todayMood ? `Feeling ${['Very Low', 'Low', 'Neutral', 'Good', 'Great'][todayMood.mood - 1]}` : 'Not checked in yet'}
        </p>
        {!todayMood && (
          <button
            onClick={onQuickCheckin}
            className="mt-3 text-sm text-blue-600 hover:underline"
          >
            Quick check-in →
          </button>
        )}
      </div>

      <div className={cardClass}>
        <div className="flex items-center justify-between mb-4">
          <Clock className="w-8 h-8 text-blue-500" />
          <span className="text-2xl font-bold">{stats.pomodoroCount}</span>
        </div>
        <h3 className="font-semibold mb-1">Focus Sessions</h3>
        <p className="text-sm text-gray-500">Completed this week</p>
      </div>

      <div className={cardClass}>
        <div className="flex items-center justify-between mb-4">
          <TrendingUp className="w-8 h-8 text-green-500" />
          <span className="text-2xl font-bold">{stats.totalMoodEntries}</span>
        </div>
        <h3 className="font-semibold mb-1">Check-ins</h3>
        <p className="text-sm text-gray-500">Total mood entries</p>
      </div>
    </div>
  );
};

export default QuickStats;